//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client';
import { getAxios, getBaseUrl } from './helpers';

export function createTestStudy(dto: Types.CreateTestStudyDto, config?: AxiosRequestConfig | undefined): Promise<Types.TestStudyDto> {
    let url_ = getBaseUrl() + "/api/test/create/study";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreateTestStudy,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreateTestStudy(_response);
    });
}

function processCreateTestStudy(response: AxiosResponse): Promise<Types.TestStudyDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.TestStudyDto.fromJS(resultData200);
        return Promise.resolve<Types.TestStudyDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.TestStudyDto>(null as any);
}

export function createTestDoctorUser(dto: Types.CreateTestDoctorDto, config?: AxiosRequestConfig | undefined): Promise<Types.TestDoctorDto> {
    let url_ = getBaseUrl() + "/api/test/create/doctor";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreateTestDoctorUser,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreateTestDoctorUser(_response);
    });
}

function processCreateTestDoctorUser(response: AxiosResponse): Promise<Types.TestDoctorDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.TestDoctorDto.fromJS(resultData200);
        return Promise.resolve<Types.TestDoctorDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.TestDoctorDto>(null as any);
}

export function createTherapyData(data: Types.CreateTestTherapyDataDto[], studyId?: number | undefined, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/test/create/therapy?";
    if (studyId === null)
        throw new Error("The parameter 'studyId' cannot be null.");
    else if (studyId !== undefined)
        url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(data);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreateTherapyData,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Content-Type": "application/json",
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreateTherapyData(_response);
    });
}

function processCreateTherapyData(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

export function createTestPatients(studyId?: number | undefined, group?: number | undefined, count?: number | undefined, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/test/create/patients?";
    if (studyId === null)
        throw new Error("The parameter 'studyId' cannot be null.");
    else if (studyId !== undefined)
        url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
    if (group === null)
        throw new Error("The parameter 'group' cannot be null.");
    else if (group !== undefined)
        url_ += "group=" + encodeURIComponent("" + group) + "&";
    if (count === null)
        throw new Error("The parameter 'count' cannot be null.");
    else if (count !== undefined)
        url_ += "count=" + encodeURIComponent("" + count) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreateTestPatients,
        ...config,
        method: "POST",
        url: url_,
        headers: {
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreateTestPatients(_response);
    });
}

function processCreateTestPatients(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

export function createTestPatient(dto: Types.CreateTestPatientDto, config?: AxiosRequestConfig | undefined): Promise<Types.PatientDto> {
    let url_ = getBaseUrl() + "/api/test/create/patient";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreateTestPatient,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreateTestPatient(_response);
    });
}

function processCreateTestPatient(response: AxiosResponse): Promise<Types.PatientDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.PatientDto.fromJS(resultData200);
        return Promise.resolve<Types.PatientDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PatientDto>(null as any);
}

export function actualizeSurveyStatuses(patientId?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/test/update/surveys?";
    if (patientId === null)
        throw new Error("The parameter 'patientId' cannot be null.");
    else if (patientId !== undefined)
        url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigActualizeSurveyStatuses,
        ...config,
        method: "POST",
        url: url_,
        headers: {
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processActualizeSurveyStatuses(_response);
    });
}

function processActualizeSurveyStatuses(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

export function moveAllPatientProcessesToDate(studyId?: number | undefined, patientUniqueId?: string | undefined, amountOfDays?: number | undefined, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/test/update/patient?";
    if (studyId === null)
        throw new Error("The parameter 'studyId' cannot be null.");
    else if (studyId !== undefined)
        url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
    if (patientUniqueId === null)
        throw new Error("The parameter 'patientUniqueId' cannot be null.");
    else if (patientUniqueId !== undefined)
        url_ += "patientUniqueId=" + encodeURIComponent("" + patientUniqueId) + "&";
    if (amountOfDays === null)
        throw new Error("The parameter 'amountOfDays' cannot be null.");
    else if (amountOfDays !== undefined)
        url_ += "amountOfDays=" + encodeURIComponent("" + amountOfDays) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigMoveAllPatientProcessesToDate,
        ...config,
        method: "POST",
        url: url_,
        headers: {
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processMoveAllPatientProcessesToDate(_response);
    });
}

function processMoveAllPatientProcessesToDate(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Saves answer for given survey and user if it is possible (if it has NOT expired yet).
 * @param dto Answer DTO.
 * @param studyId (optional) Related study Id.
 * @return Id of saved/created/updated answer entity.
 */
export function saveAnswer(dto: Types.AnswerResultDto, studyId?: number | undefined, config?: AxiosRequestConfig | undefined): Promise<number> {
    let url_ = getBaseUrl() + "/api/test/answer?";
    if (studyId === null)
        throw new Error("The parameter 'studyId' cannot be null.");
    else if (studyId !== undefined)
        url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigSaveAnswer,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSaveAnswer(_response);
    });
}

function processSaveAnswer(response: AxiosResponse): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
        return Promise.resolve<number>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<number>(null as any);
}

export function getQuestionnaire(studyId?: number | undefined, patientId?: string | undefined, surveyType?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.QuestionnaireDto[]> {
    let url_ = getBaseUrl() + "/api/test/questionnaires?";
    if (studyId === null)
        throw new Error("The parameter 'studyId' cannot be null.");
    else if (studyId !== undefined)
        url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
    if (patientId === null)
        throw new Error("The parameter 'patientId' cannot be null.");
    else if (patientId !== undefined)
        url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
    if (surveyType === null)
        throw new Error("The parameter 'surveyType' cannot be null.");
    else if (surveyType !== undefined)
        url_ += "surveyType=" + encodeURIComponent("" + surveyType) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetQuestionnaire,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetQuestionnaire(_response);
    });
}

function processGetQuestionnaire(response: AxiosResponse): Promise<Types.QuestionnaireDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
                result200!.push(Types.QuestionnaireDto.fromJS(item));
        }
        else {
            result200 = <any>null;
        }
        return Promise.resolve<Types.QuestionnaireDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.QuestionnaireDto[]>(null as any);
}

export function createQuestionnaire(patientId: string, surveyId: number, startDate: Date, endDate: Date, studyId?: number | null | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.QuestionnaireDto> {
    let url_ = getBaseUrl() + "/api/test/questionnaires?";
      if (patientId === undefined || patientId === null)
        throw new Error("The parameter 'patientId' must be defined and cannot be null.");
      else
        url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
      if (surveyId === undefined || surveyId === null)
        throw new Error("The parameter 'surveyId' must be defined and cannot be null.");
      else
        url_ += "surveyId=" + encodeURIComponent("" + surveyId) + "&";
      if (startDate === undefined || startDate === null)
        throw new Error("The parameter 'startDate' must be defined and cannot be null.");
      else
        url_ += "startDate=" + encodeURIComponent(startDate ? "" + Types.formatDate(startDate) : "") + "&";
      if (endDate === undefined || endDate === null)
        throw new Error("The parameter 'endDate' must be defined and cannot be null.");
      else
        url_ += "endDate=" + encodeURIComponent(endDate ? "" + Types.formatDate(endDate) : "") + "&";
    if (studyId !== undefined && studyId !== null)
        url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreateQuestionnaire,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreateQuestionnaire(_response);
    });
}

function processCreateQuestionnaire(response: AxiosResponse): Promise<Types.QuestionnaireDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.QuestionnaireDto.fromJS(resultData200);
        return Promise.resolve<Types.QuestionnaireDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.QuestionnaireDto>(null as any);
}

export function getSurveysForDoctor(studyId?: number | undefined, doctorId?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.SurveyDto[]> {
    let url_ = getBaseUrl() + "/api/test/surveys?";
    if (studyId === null)
        throw new Error("The parameter 'studyId' cannot be null.");
    else if (studyId !== undefined)
        url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
    if (doctorId === null)
        throw new Error("The parameter 'doctorId' cannot be null.");
    else if (doctorId !== undefined)
        url_ += "doctorId=" + encodeURIComponent("" + doctorId) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetSurveysForDoctor,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetSurveysForDoctor(_response);
    });
}

function processGetSurveysForDoctor(response: AxiosResponse): Promise<Types.SurveyDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
                result200!.push(Types.SurveyDto.fromJS(item));
        }
        else {
            result200 = <any>null;
        }
        return Promise.resolve<Types.SurveyDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.SurveyDto[]>(null as any);
}

export function getSurveyRulesForDoctor(studyId?: number | undefined, doctorId?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.SurveyRuleDto[]> {
    let url_ = getBaseUrl() + "/api/test/surveys/rules?";
    if (studyId === null)
        throw new Error("The parameter 'studyId' cannot be null.");
    else if (studyId !== undefined)
        url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
    if (doctorId === null)
        throw new Error("The parameter 'doctorId' cannot be null.");
    else if (doctorId !== undefined)
        url_ += "doctorId=" + encodeURIComponent("" + doctorId) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetSurveyRulesForDoctor,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetSurveyRulesForDoctor(_response);
    });
}

function processGetSurveyRulesForDoctor(response: AxiosResponse): Promise<Types.SurveyRuleDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
                result200!.push(Types.SurveyRuleDto.fromJS(item));
        }
        else {
            result200 = <any>null;
        }
        return Promise.resolve<Types.SurveyRuleDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.SurveyRuleDto[]>(null as any);
}

export function triggerTaskForStudy(dto: Types.TriggerScheduledTaskDto, config?: AxiosRequestConfig | undefined): Promise<string[]> {
    let url_ = getBaseUrl() + "/api/test/scheduledTasks";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigTriggerTaskForStudy,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processTriggerTaskForStudy(_response);
    });
}

function processTriggerTaskForStudy(response: AxiosResponse): Promise<string[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
                result200!.push(item);
        }
        else {
            result200 = <any>null;
        }
        return Promise.resolve<string[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<string[]>(null as any);
}

export function deletePatients(studyId?: number | undefined, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/test/delete/patients?";
    if (studyId === null)
        throw new Error("The parameter 'studyId' cannot be null.");
    else if (studyId !== undefined)
        url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigDeletePatients,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processDeletePatients(_response);
    });
}

function processDeletePatients(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

export function getPatientInfoByUniqueId(patientUniqueId?: string | undefined, studyId?: number | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.PatientDto> {
    let url_ = getBaseUrl() + "/api/test/patient/info?";
    if (patientUniqueId === null)
        throw new Error("The parameter 'patientUniqueId' cannot be null.");
    else if (patientUniqueId !== undefined)
        url_ += "patientUniqueId=" + encodeURIComponent("" + patientUniqueId) + "&";
    if (studyId === null)
        throw new Error("The parameter 'studyId' cannot be null.");
    else if (studyId !== undefined)
        url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetPatientInfoByUniqueId,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetPatientInfoByUniqueId(_response);
    });
}

function processGetPatientInfoByUniqueId(response: AxiosResponse): Promise<Types.PatientDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.PatientDto.fromJS(resultData200);
        return Promise.resolve<Types.PatientDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PatientDto>(null as any);
}
let _requestConfigCreateTestStudy: Partial<AxiosRequestConfig> | null;
export function getCreateTestStudyRequestConfig() {
  return _requestConfigCreateTestStudy;
}
export function setCreateTestStudyRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreateTestStudy = value;
}
export function patchCreateTestStudyRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreateTestStudy = patch(_requestConfigCreateTestStudy ?? {});
}

let _requestConfigCreateTestDoctorUser: Partial<AxiosRequestConfig> | null;
export function getCreateTestDoctorUserRequestConfig() {
  return _requestConfigCreateTestDoctorUser;
}
export function setCreateTestDoctorUserRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreateTestDoctorUser = value;
}
export function patchCreateTestDoctorUserRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreateTestDoctorUser = patch(_requestConfigCreateTestDoctorUser ?? {});
}

let _requestConfigCreateTherapyData: Partial<AxiosRequestConfig> | null;
export function getCreateTherapyDataRequestConfig() {
  return _requestConfigCreateTherapyData;
}
export function setCreateTherapyDataRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreateTherapyData = value;
}
export function patchCreateTherapyDataRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreateTherapyData = patch(_requestConfigCreateTherapyData ?? {});
}

let _requestConfigCreateTestPatients: Partial<AxiosRequestConfig> | null;
export function getCreateTestPatientsRequestConfig() {
  return _requestConfigCreateTestPatients;
}
export function setCreateTestPatientsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreateTestPatients = value;
}
export function patchCreateTestPatientsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreateTestPatients = patch(_requestConfigCreateTestPatients ?? {});
}

let _requestConfigCreateTestPatient: Partial<AxiosRequestConfig> | null;
export function getCreateTestPatientRequestConfig() {
  return _requestConfigCreateTestPatient;
}
export function setCreateTestPatientRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreateTestPatient = value;
}
export function patchCreateTestPatientRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreateTestPatient = patch(_requestConfigCreateTestPatient ?? {});
}

let _requestConfigActualizeSurveyStatuses: Partial<AxiosRequestConfig> | null;
export function getActualizeSurveyStatusesRequestConfig() {
  return _requestConfigActualizeSurveyStatuses;
}
export function setActualizeSurveyStatusesRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigActualizeSurveyStatuses = value;
}
export function patchActualizeSurveyStatusesRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigActualizeSurveyStatuses = patch(_requestConfigActualizeSurveyStatuses ?? {});
}

let _requestConfigMoveAllPatientProcessesToDate: Partial<AxiosRequestConfig> | null;
export function getMoveAllPatientProcessesToDateRequestConfig() {
  return _requestConfigMoveAllPatientProcessesToDate;
}
export function setMoveAllPatientProcessesToDateRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigMoveAllPatientProcessesToDate = value;
}
export function patchMoveAllPatientProcessesToDateRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigMoveAllPatientProcessesToDate = patch(_requestConfigMoveAllPatientProcessesToDate ?? {});
}

let _requestConfigSaveAnswer: Partial<AxiosRequestConfig> | null;
export function getSaveAnswerRequestConfig() {
  return _requestConfigSaveAnswer;
}
export function setSaveAnswerRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSaveAnswer = value;
}
export function patchSaveAnswerRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSaveAnswer = patch(_requestConfigSaveAnswer ?? {});
}

let _requestConfigGetQuestionnaire: Partial<AxiosRequestConfig> | null;
export function getGetQuestionnaireRequestConfig() {
  return _requestConfigGetQuestionnaire;
}
export function setGetQuestionnaireRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetQuestionnaire = value;
}
export function patchGetQuestionnaireRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetQuestionnaire = patch(_requestConfigGetQuestionnaire ?? {});
}

let _requestConfigCreateQuestionnaire: Partial<AxiosRequestConfig> | null;
export function getCreateQuestionnaireRequestConfig() {
  return _requestConfigCreateQuestionnaire;
}
export function setCreateQuestionnaireRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreateQuestionnaire = value;
}
export function patchCreateQuestionnaireRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreateQuestionnaire = patch(_requestConfigCreateQuestionnaire ?? {});
}

let _requestConfigGetSurveysForDoctor: Partial<AxiosRequestConfig> | null;
export function getGetSurveysForDoctorRequestConfig() {
  return _requestConfigGetSurveysForDoctor;
}
export function setGetSurveysForDoctorRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetSurveysForDoctor = value;
}
export function patchGetSurveysForDoctorRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetSurveysForDoctor = patch(_requestConfigGetSurveysForDoctor ?? {});
}

let _requestConfigGetSurveyRulesForDoctor: Partial<AxiosRequestConfig> | null;
export function getGetSurveyRulesForDoctorRequestConfig() {
  return _requestConfigGetSurveyRulesForDoctor;
}
export function setGetSurveyRulesForDoctorRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetSurveyRulesForDoctor = value;
}
export function patchGetSurveyRulesForDoctorRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetSurveyRulesForDoctor = patch(_requestConfigGetSurveyRulesForDoctor ?? {});
}

let _requestConfigTriggerTaskForStudy: Partial<AxiosRequestConfig> | null;
export function getTriggerTaskForStudyRequestConfig() {
  return _requestConfigTriggerTaskForStudy;
}
export function setTriggerTaskForStudyRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigTriggerTaskForStudy = value;
}
export function patchTriggerTaskForStudyRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigTriggerTaskForStudy = patch(_requestConfigTriggerTaskForStudy ?? {});
}

let _requestConfigDeletePatients: Partial<AxiosRequestConfig> | null;
export function getDeletePatientsRequestConfig() {
  return _requestConfigDeletePatients;
}
export function setDeletePatientsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigDeletePatients = value;
}
export function patchDeletePatientsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigDeletePatients = patch(_requestConfigDeletePatients ?? {});
}

let _requestConfigGetPatientInfoByUniqueId: Partial<AxiosRequestConfig> | null;
export function getGetPatientInfoByUniqueIdRequestConfig() {
  return _requestConfigGetPatientInfoByUniqueId;
}
export function setGetPatientInfoByUniqueIdRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetPatientInfoByUniqueId = value;
}
export function patchGetPatientInfoByUniqueIdRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetPatientInfoByUniqueId = patch(_requestConfigGetPatientInfoByUniqueId ?? {});
}